import React, { useEffect } from 'react';
import { Navigation } from '../../components/feature/Navigation';
import { HeroSection } from './components/HeroSection';
import { VisionSection } from './components/VisionSection';
import { ProductsSection } from './components/ProductsSection';
import { LeapSection } from './components/LeapSection';
import { ContactSection } from './components/ContactSection';

export default function Home() {
  useEffect(() => {
    // Add smooth scrolling behavior
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Intersection Observer for scroll animations
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
        }
      });
    }, observerOptions);

    // Observe all sections
    const sections = document.querySelectorAll('section');
    sections.forEach((section) => observer.observe(section));

    return () => {
      observer.disconnect();
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="min-h-screen bg-brand-indigo text-brand-off-white overflow-x-hidden">
      <Navigation />
      <main>
        <HeroSection />
        <VisionSection />
        <ProductsSection />
        <LeapSection />
        <ContactSection />
      </main>
      
      {/* Footer */}
      <footer className="bg-brand-indigo border-t border-brand-teal/20 py-8">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="flex items-center mb-4 md:mb-0">
              <div className="w-8 h-8 mr-3 relative">
                <div className="absolute inset-0 bg-brand-teal/20 rounded-full blur-sm"></div>
                <img 
                  src="https://static.readdy.ai/image/7c34e572229199a03c653ba249394690/86126c0a2c4a8a5efa2a79660917f6e5.png" 
                  alt="Whence Logo" 
                  className="w-full h-full object-contain relative z-10 drop-shadow-lg filter brightness-110"
                  style={{ filter: 'drop-shadow(0 0 6px rgba(29, 211, 176, 0.3))' }}
                />
              </div>
              <h3 className="text-2xl font-bold text-brand-off-white font-pacifico mr-4">Whence</h3>
              <span className="text-gray-400">The bridge to AGI</span>
            </div>
            <div className="text-gray-400 text-sm">
              © 2024 Whence. Shaping the future of intelligence.
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
